import { CELLPHONE_RECOVERY_OPERATIONS } from '../constants/cellphone_recovery_operations';

export default {
    props: {
        operation: {
            type: String,
            required: true,
            validator(val) {
                const isOPerationValid = Object.values(CELLPHONE_RECOVERY_OPERATIONS).includes(val);

                return isOPerationValid;
            },
        },
    },
};
